module.exports = __webpack_public_path__ + "static/media/tourney_bracket.d79bf194.png";